import { Flex, FormField, FormHelp, Heading, Input, Label } from '@zillow/constellation';
import { useFormContext } from 'react-hook-form';

const maxLengthValidation = { value: 32, message: 'Please enter a name under 32 characters' };

export function LegalNameStep() {
  const {
    formState: { errors },
    register,
  } = useFormContext();

  return (
    <>
      <Heading level={4} as="h2" marginBottom="sm" fontFamily="serif">
        What is your legal name?
      </Heading>
      <Flex display="flex" flexDirection="column" gap="sm">
        <FormField
          label={<Label>First name</Label>}
          control={
            <Input
              maxLength={maxLengthValidation.value}
              {...register('firstName', {
                required: 'First name is required',
              })}
            />
          }
          description={errors.firstName && <FormHelp>{errors.firstName.message}</FormHelp>}
          error={!!errors.firstName}
        />
        <FormField
          label={<Label>Middle name</Label>}
          control={<Input maxLength={maxLengthValidation.value} {...register('middleName')} />}
          description={
            errors.middleName ? (
              <FormHelp>{errors.middleName.message}</FormHelp>
            ) : (
              <FormHelp>Leave blank if you do not have a middle name</FormHelp>
            )
          }
          optional
          error={!!errors.middleName}
        />
        <FormField
          label={<Label>Last name</Label>}
          control={
            <Input
              maxLength={maxLengthValidation.value}
              {...register('lastName', { required: 'Last name is required' })}
            />
          }
          description={errors.lastName && <FormHelp>{errors.lastName.message}</FormHelp>}
          error={!!errors.lastName}
        />
      </Flex>
    </>
  );
}
